const carouselItems = [
  {
    title: '古风耽美 · 经典盛宴',
    desc: '权倾朝野、江湖侠骨、宫闱秘事……沉浸式体验古代绝世情缘，精选百部高分古风耽美漫画，画风绝美，剧情在线。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20ancient%20Chinese%20fantasy%20art%20two%20male%20characters%20in%20magnificent%20hanfu%20robes%20standing%20on%20mountain%20peak%20at%20sunrise%20swords%20in%20hand%20flowing%20fabric%20in%20wind%20ancient%20palace%20in%20distance%20golden%20morning%20light%20grand%20cinematic%20anime%20illustration%20rich%20detail&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '古风专题',
  },
  {
    title: '校园青春 · 纯爱物语',
    desc: '教室的午后阳光、篮球场的汗水、图书馆的偶遇——最纯粹的少年心事与初恋悸动，都在这里等你重温。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20school%20life%20anime%20art%20two%20male%20students%20walking%20together%20through%20school%20courtyard%20lined%20with%20cherry%20blossom%20trees%20spring%20sunlight%20dappled%20shadows%20school%20building%20background%20soft%20pastel%20color%20palette%20warm%20gentle%20atmosphere%20anime%20illustration&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '青春专题',
  },
  {
    title: '悬疑探案 · 心跳解密',
    desc: '都市暗影中的连环案件，智商在线的刑侦搭档，在追凶中揭开人性的复杂与深情。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20detective%20anime%20art%20two%20male%20characters%20in%20dark%20trench%20coats%20standing%20in%20rainy%20city%20street%20at%20night%20neon%20signs%20reflecting%20on%20wet%20pavement%20moody%20atmosphere%20dark%20blue%20and%20amber%20lighting%20cinematic%20film%20noir%20style%20anime%20illustration&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '悬疑专题',
  },
  {
    title: '仙侠修真 · 三生三世',
    desc: '御剑飞行、仙魔大战、轮回转世——跨越三界的宏大世界观，书写刻骨铭心的仙途情缘。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20xianxia%20fantasy%20anime%20art%20two%20male%20immortal%20characters%20in%20white%20flowing%20robes%20floating%20above%20clouds%20amidst%20floating%20mountain%20peaks%20celestial%20palaces%20in%20background%20golden%20and%20pearl%20mystical%20lighting%20swirling%20energy%20grand%20scale%20detailed%20anime%20illustration&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '仙侠专题',
  },
  {
    title: '现代都市 · 职场情缘',
    desc: '摩天大楼的落地窗前、深夜加班的办公室、霓虹闪烁的街角——当代都市人的爱与成长故事。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20modern%20urban%20anime%20art%20two%20stylish%20male%20characters%20in%20business%20attire%20standing%20on%20city%20rooftop%20overlooking%20skyline%20at%20twilight%20golden%20hour%20lighting%20skyscrapers%20with%20lights%20turning%20on%20warm%20atmospheric%20contemporary%20anime%20illustration&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '都市专题',
  },
  {
    title: '奇幻异世 · 魔法冒险',
    desc: '异世界的大门已经打开，魔法学院、龙族秘境、精灵森林——在想象力的尽头邂逅命定之人。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20fantasy%20adventure%20anime%20art%20two%20male%20adventurers%20standing%20at%20entrance%20of%20magical%20forest%20one%20holding%20staff%20one%20with%20sword%20ancient%20ruins%20covered%20in%20vines%20glowing%20magical%20particles%20warm%20golden%20and%20emerald%20lighting%20sense%20of%20wonder%20detailed%20anime%20illustration&width=1200&height=600&seq=carousel-06&orientation=landscape',
    tag: '奇幻专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500">六大主题专区，总有一款击中你的心</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className="group block bg-background-100 rounded-lg overflow-hidden"
            >
              <div className="relative aspect-[2/1] overflow-hidden bg-secondary-200">
                <img
                  src={item.image}
                  alt={`耽美漫画专题 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="text-[11px] px-2 py-0.5 bg-primary-500 text-background-50 rounded-full font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}